<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form :model="where" label-width="90px" class="ele-form-search"
        @keyup.enter.native="reload" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="运营商名称">
              <el-input clearable v-model.trim="where.name" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="租户编码">
              <el-input clearable v-model.trim="where.code" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="状态">
              <el-select clearable v-model="where.status" placeholder="请选择" class="ele-block">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <ele-pro-table ref="table" :where="where" :datasource="url" :columns="columns" :selection.sync="selection"
        height="calc(100vh - 315px)">
        <template slot="toolbar">
          <el-button size="small" type="primary" icon="el-icon-plus" class="ele-btn-icon" @click="openEdit(null)">
            添加
          </el-button>
          <el-button size="small" type="danger" icon="el-icon-delete" class="ele-btn-icon" :disabled="!selection.length" @click="removeBatch">
            删除
          </el-button>
        </template>
        <template slot="status" slot-scope="{ row }">
          <el-switch
            v-model="row.status"
            :active-value="1"
            :inactive-value="2"
            @change="editStatus(row)" />
        </template>
        <template slot="action" slot-scope="{ row }">
          <el-button size="small" type="primary" class="ele-btn-icon" @click="openEdit(row)">编辑</el-button>
          <el-button v-if="row.id !== 1" size="small" type="warning" class="ele-btn-icon" @click="provision(row)">初始化</el-button>
          <el-popconfirm v-if="row.id !== 1" class="ele-action" title="确定要删除该运营商吗？" @confirm="remove(row)">
            <el-button size="small" type="danger" class="ele-btn-icon" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </ele-pro-table>
    </el-card>
    <tenant-edit :data="current" :visible.sync="showEdit" @done="reload" />
  </div>
</template>

<script>
import { loadDictOptions } from '@/utils/dict';
import TenantEdit from './tenant-edit';

export default {
  name: 'SystemTenant',
  components: { TenantEdit },
  data() {
    return {
      url: '/tenant/index',
      where: {},
      current: null,
      showEdit: false,
      selection: [],
      statusOptions: [],
      columns: [
        { columnKey: 'selection', type: 'selection', width: 45, align: 'center', fixed: 'left' },
        { prop: 'id', label: '序号', width: 70, align: 'center' },
        { prop: 'name', label: '运营商名称', minWidth: 120, align: 'center', showOverflowTooltip: true },
        { prop: 'code', label: '租户编码', minWidth: 100, align: 'center', showOverflowTooltip: true },
        { prop: 'admin_domain', label: '运营前端', minWidth: 140, align: 'center', showOverflowTooltip: true },
        { prop: 'merchant_domain', label: '商户前端', minWidth: 140, align: 'center', showOverflowTooltip: true },
        { prop: 'finance_domain', label: '金主前端', minWidth: 140, align: 'center', showOverflowTooltip: true },
        { prop: 'api_domain', label: 'OpenAPI', minWidth: 140, align: 'center', showOverflowTooltip: true },
        { prop: 'landing_domain', label: '落地前端', minWidth: 140, align: 'center', showOverflowTooltip: true },
        { prop: 'status', label: '状态', width: 90, align: 'center', slot: 'status' },
        {
          prop: 'create_time',
          label: '创建时间',
          minWidth: 150,
          align: 'center',
          formatter: (row, column, cellValue) => this.$util.toDateString(cellValue)
        },
        { columnKey: 'action', label: '操作', width: 230, align: 'center', slot: 'action', fixed: 'right' }
      ]
    };
  },
  mounted() {
    loadDictOptions('enable_status', { numberValue: true })
      .then((list) => { this.statusOptions = list; })
      .catch((e) => { this.$message.error(e.message); });
  },
  methods: {
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    reset() {
      this.where = {};
      this.reload();
    },
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    },
    remove(row) {
      this.$http.post('/tenant/delete', { id: row.id }).then(res => {
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.reload();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error('请选择');
        return;
      }
      if (this.selection.some(item => item.id === 1)) {
        this.$message.error('默认运营商不可删除');
        return;
      }
      this.$confirm('确定要删除选中的运营商吗？', '提示', { type: 'warning' }).then(() => {
        const ids = this.selection.map(d => d.id);
        Promise.all(ids.map(id => this.$http.post('/tenant/delete', { id }))).then(() => {
          this.$message.success('删除成功');
          this.reload();
        });
      });
    },
    editStatus(row) {
      const previousStatus = row.status === 1 ? 2 : 1;
      this.$http.post('/tenant/status', { id: row.id, status: row.status }).then(res => {
        if (res.data.code === 0) {
          this.$message.success(res.data.msg || '状态已更新');
        } else {
          row.status = previousStatus;
          this.$message.error(res.data.msg);
        }
      }).catch(() => {
        row.status = previousStatus;
        this.$message.error('状态更新失败');
      });
    },
    provision(row) {
      this.$confirm(
        '从默认运营商（ID=1）复制系统参数、字典、角色、渠道类型。仅在该租户对应数据为空时才会写入。',
        '初始化租户数据',
        { type: 'warning' }
      ).then(() => {
        this.$http.post('/tenant/provision', {
          id: row.id,
          source_tenant_id: 1,
          types: 'config,dict,role,channel'
        }).then(res => {
          if (res.data.code === 0) {
            const d = res.data.data || {};
            this.$message.success(
              `完成：配置 ${d.config || 0} 条，字典 ${d.dict || 0} 个，角色 ${d.role || 0} 个，渠道类型 ${d.channel || 0} 条`
            );
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }).catch(() => {});
    }
  }
};
</script>
